import React from "react";

import { Toggle } from "../../components/ui";
import {
  LINE_BUY_BUDGET,
  LINE_EXPECTED_PRICE,
  LINE_LISTING_PRICE,
  LINE_SELL_TARGET,
  useRequestLookbook,
} from "./useRequestLookbook";

const GROUPS = [
  {
    heading: "Order request",
    lines: [
      { key: LINE_BUY_BUDGET, label: "Show buy budget" },
      { key: LINE_SELL_TARGET, label: "Show sell target" },
    ],
  },
  {
    heading: "Sell request",
    lines: [
      { key: LINE_EXPECTED_PRICE, label: "Show expected price" },
      { key: LINE_LISTING_PRICE, label: "Show listing price" },
    ],
  },
];

// `external` is the persisted key (lookbooks.data.copies, LookbookService);
// only the label is "Network copy".
const COPIES = [
  { key: "external", heading: "Network copy", hint: "Sent to the network" },
  { key: "admin", heading: "Admin copy", hint: "Kept internally" },
];

/**
 * Which money lines each copy prints.
 *
 * Every generation produces BOTH PDFs; these toggles are the only difference
 * between them. A line prints only when the request carries a figure AND its
 * toggle is on for that copy — which is why the usual setup is an admin copy
 * showing everything and a network copy without the selling figures.
 */
export const CopyToggles = () => {
  const { copies, toggleCopyLine } = useRequestLookbook();

  return (
    <div className="rlb-copies">
      {COPIES.map((copy) => (
        <section className="rlb-copies__copy" key={copy.key}>
          <header className="rlb-copies__head">
            <span className="rlb-copies__title">{copy.heading}</span>
            <span className="rlb-copies__hint">{copy.hint}</span>
          </header>

          {GROUPS.map((group) => (
            <div className="rlb-copies__group" key={group.heading}>
              <span className="rlb-copies__group-heading">{group.heading}</span>
              {group.lines.map((line) => (
                <Toggle
                  key={line.key}
                  className="rlb-copies__toggle"
                  checked={!!copies[copy.key]?.[line.key]}
                  onChange={() => toggleCopyLine(copy.key, line.key)}
                  label={line.label}
                />
              ))}
            </div>
          ))}
        </section>
      ))}
    </div>
  );
};

export default CopyToggles;
